/**
 * @fileoverview Text logo component for Project-Korvo
 * 
 * @purpose Displays "Project-Korvo" as a text-based logo with bold styling
 * @usage Used in TopBar and homepage components to replace image logo
 * @ownership Core shared components
 * @dependencies None
 * @restrictions None
 */

type LogoProps = {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

export function Logo({ size = 'md', className = '' }: LogoProps) {
  const sizeClasses = {
    sm: 'text-lg',
    md: 'text-2xl',
    lg: 'text-4xl',
  };

  return (
    <span
      className={`font-bold text-foreground ${sizeClasses[size]} ${className}`}
      style={{ fontFamily: 'system-ui, -apple-system, sans-serif' }}
    >
      Project-Korvo
    </span>
  );
}

